<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="pagination">
    Stránka {{ page }} z {{ pages }}:
    <button :disabled="page <= 1" class="button is-text" @click="$emit('prev')">
      předešlá
    </button>
    |
    <button
      :disabled="page >= pages"
      class="button is-text"
      @click="$emit('next')"
    >
      další
    </button>
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: Number
    },
    pages: {
      type: Number
    }
  }
};
</script>
<style scoped lang="scss">
.pagination {
  display: flex;
  align-items: center;
}
</style>
